import React from 'react';

import { Progress as ProgressCore, ProgressProps } from 'antd';

import styles from './ProgressBar.module.scss';

interface IProgressBarProps extends ProgressProps {}

const ProgressBar = (props: IProgressBarProps) => {
	return <ProgressCore {...props} className={styles.progressBar} />;
};

export default ProgressBar;
